import { useRef } from 'react';

import OBJECTIVE_FORM_KEYS from 'apps/web/constants/forms/objective/formKeys';
import useAutosizeTextArea from 'apps/web/hooks/useAutoSizeTextArea';
import processInput from 'apps/web/utils/formInput';

import { TextAreaField, TextField } from '../form-fields';
import {
  FrameworkDropdown,
  GradeLevelDropdown,
  StateDropdown,
} from '../Select';

export default function AmericanObjective({
  errors,
  watchedValues,
  triggerValidation,
  setValue,
}: {
  errors;
  watchedValues;
  triggerValidation;
  setValue;
}) {
  const standardRef = useRef<HTMLTextAreaElement>(null);
  const benchmarkRef = useRef<HTMLTextAreaElement>(null);

  useAutosizeTextArea(standardRef.current, watchedValues.standard);
  useAutosizeTextArea(benchmarkRef.current, watchedValues.benchmark);

  return (
    <>
      <FrameworkDropdown
        error={errors.curriculumFramework}
        label="Curriculum Framework"
        value={watchedValues.curriculumFramework}
        errorMessage={
          !!errors.curriculumFramework && 'Please select a Framework'
        }
        onBlur={() => {
          triggerValidation(OBJECTIVE_FORM_KEYS.curriculumFramework);
        }}
        onChange={(value) =>
          setValue(OBJECTIVE_FORM_KEYS.curriculumFramework, value)
        }
      />
      <TextField
        className="col-span-full"
        errorMessage={!!errors.subject && 'Please enter the subject'}
        id={OBJECTIVE_FORM_KEYS.subject}
        label="Subject"
        name={OBJECTIVE_FORM_KEYS.subject}
        placeholder="ex. Science, Music, etc."
        type="text"
        value={watchedValues.subject}
        onBlur={() => {
          processInput(
            setValue,
            triggerValidation,
            OBJECTIVE_FORM_KEYS.subject,
            watchedValues.subject?.trim() || '',
          );
        }}
        onChange={(e) => {
          processInput(
            setValue,
            triggerValidation,
            OBJECTIVE_FORM_KEYS.subject,
            e.target.value,
          );
        }}
      />
      <GradeLevelDropdown
        error={!!errors.gradeLevel}
        errorMessage={!!errors.gradeLevel && 'Please select the Grade Level'}
        value={watchedValues.gradeLevel}
        onChange={(value) => setValue(OBJECTIVE_FORM_KEYS.gradeLevel, value)}
        onBlur={() => {
          triggerValidation(OBJECTIVE_FORM_KEYS.gradeLevel);
        }}
      />
      <StateDropdown
        error={errors.specificStandards}
        label="State Standard"
        value={watchedValues.specificStandards}
        errorMessage={
          !!errors.specificStandards && 'Please select a State Standard'
        }
        onBlur={() => {
          triggerValidation(OBJECTIVE_FORM_KEYS.specificStandards);
        }}
        onChange={(value) =>
          setValue(OBJECTIVE_FORM_KEYS.specificStandards, value)
        }
      />
      <TextAreaField
        showSubLabel
        className="col-span-full"
        error={!!errors.objectives}
        id={OBJECTIVE_FORM_KEYS.objectives}
        label="Learning Benchmark"
        name={OBJECTIVE_FORM_KEYS.objectives}
        placeholder="Input the desired learning benchmark and outcomes"
        rows={2}
        subLabel="This can be based on the State or School"
        textAreaRef={benchmarkRef}
        type="text"
        value={watchedValues.objectives}
        errorMessage={
          !!errors.objectives && 'Please enter the benchmark/outcomes'
        }
        onBlur={() => {
          processInput(
            setValue,
            triggerValidation,
            OBJECTIVE_FORM_KEYS.objectives,
            watchedValues.objectives?.trim() || '',
          );
        }}
        onChange={(e) =>
          processInput(
            setValue,
            triggerValidation,
            OBJECTIVE_FORM_KEYS.objectives,
            e.target.value,
          )
        }
      />
    </>
  );
}
